export function setTransactions(state, transactions){
  state.transactions = transactions
}

export function setProjects(state, projects) {
  state.projects = projects;
}

export function setProjectsTable(state, projects) {
  state.projects = projects.data;

  delete projects.data;

  state.projectsTable.pagination = projects;
}



// WEBPACK FOOTER //
// ./src/modules/project-movements/mutations.js